export default class productConfigOptionsApi {
    constructor(axios, pid, billing) {
        this.axios = axios
        this.pid = pid
        this.billingcycle = billing
    }

    getPrices() {
        
        return this.axios.get('index.php?m=proxycheap&json=1&c=ProductConfigOptions&billing='+this.billingcycle+'&pid='+this.pid)
    }
}
